<template>
    <span v-if="readonly"> {{ item?.name || "-" }} </span>
    <v-autocomplete v-else v-model="$data._order" v-bind="{ ...$attrs, items, itemText, itemValue: '_id' }" @click="alert" />
</template>

<script>
import api from "@/api";

export default {
    props: {
        value: { type: [String, Array], default: null },
        params: { type: [Object, Array], default: () => ({}) },
        readonly: { type: Boolean, default: false },
    },
    data: () => ({
        _order: null,
        items: [],
    }),
    computed: {
        item() {
            return this.items.find(({ _id }) => _id == this.$data._order);
        },
    },
    mounted() {
        this.sync();
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
        params() {
            this.init();
        },
        "$data._order"(_order) {
            this.$emit("input", _order);
        },
    },
    methods: {
        sync() {
            this.$data._order = this.value;
        },
        async init() {
            if (this.$attrs.disabled) return;
            let { params } = this;
            this.items = (await api.console.shop.purchaseOrders.gets({ params }))?.orders || [];
        },
        itemText({ number, typeTextShorten }) {
            return `${number} / ${typeTextShorten}`;
        },
        alert() {
            if (this.$attrs.readonly && this.$attrs.readonlyMessage) alert(this.$attrs.readonlyMessage);
            if (this.$attrs.disabled && this.$attrs.disabledMessage) alert(this.$attrs.readonlyMessage);
        },
    },
};
</script>

<style></style>
